module.exports = __webpack_public_path__ + "media/src/assets/img/elements/macbook-pro-e723c891248adeb4e66a9976624171f3.png";